import { useEffect } from "react";

const useShouldComponentUpdate = (callback: Function) => {
  useEffect(() => {
    callback();
  }, [callback]);
};

export default useShouldComponentUpdate;
